<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [showHeader]="false"
  [dismissableMask]="false"
  [style]="{ width: 'min(520px, 94vw)' }"
  styleClass="welcome-setup-dialog"
>
  <div class="welcome-header">
    <button type="button" class="welcome-close" (click)="dismiss()">
      <i class="pi pi-times"></i>
    </button>
    <div class="welcome-check">
      <i class="pi pi-check"></i>
    </div>
    <div class="welcome-title">Welcome to LincSell{{ displayName ? ', ' + displayName : '' }}</div>
    <div class="welcome-subtitle">
      Your account is live. {{ visibleSteps.length }} short steps stand between you and your first sale — most people finish in under ten minutes.
    </div>
  </div>

  <div class="welcome-body">
    <div class="welcome-body-label">What setup covers</div>

    <ng-container *ngIf="isLoadingProgress">
      <div class="welcome-step welcome-step-skeleton" *ngFor="let row of [1,2,3,4,5,6]">
        <p-skeleton shape="circle" size="22px"></p-skeleton>
        <div class="welcome-step-skeleton-text">
          <p-skeleton width="60%" height="14px" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="90%" height="11px"></p-skeleton>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoadingProgress">
      <div class="welcome-step" *ngFor="let step of visibleSteps; let i = index" [class.completed]="isStepComplete(step)">
        <span class="welcome-step-index" [class.completed]="isStepComplete(step)">
          <i class="pi pi-check" *ngIf="isStepComplete(step)"></i>
          <ng-container *ngIf="!isStepComplete(step)">{{ i + 1 }}</ng-container>
        </span>
        <div>
          <div class="welcome-step-title">{{ step.title }}</div>
          <div class="welcome-step-desc">{{ step.description }}</div>
        </div>
      </div>
    </ng-container>

    <div class="welcome-note">
      <i class="pi pi-clock"></i>
      <span>Nothing is charged today. You can leave any step and come back — your progress is saved as you go.</span>
    </div>
  </div>

  <div class="welcome-footer">
    <button pButton type="button" class="welcome-cta" label="Set up my business" (click)="startSetup()"></button>
  </div>
</p-dialog>
